import {Injectable } from '@angular/core';
import {environment} from '../../environments/environment';
import {ApiCallService} from '../api/api-call.service';
import {DbReaderService} from '../db-reader/db-reader.service';
import {map, switchMap} from 'rxjs/operators';
import {EMPTY, forkJoin, Observable, of, zip} from 'rxjs';

@Injectable()
export class ContentBlockService {

  constructor(
    private apiCallService: ApiCallService,
    private dbReaderService: DbReaderService
  ) {
  }

  public getContentBlock(zweck){
    return this.dbReaderService.get(zweck, 'Content').pipe(
      map(data => {
        if (data){
          const binaryStr = atob(data.content)
          const len = binaryStr.length;
          const bytes = new Uint8Array(len);

          for (let i = 0; i < len; i++) {
            bytes[i] = binaryStr.charCodeAt(i);
          }

          const decoder = new TextDecoder();
          return decoder.decode(bytes);
        }
      })
    )
  }

  public contentBlockAktualisieren(mandantenBlockListe: any[]): Observable<any> {
    let idListe: string[] = [];
    return this.dbReaderService.all('Content', 'value').pipe(
      switchMap(dbResponse => {
        if (dbResponse.length > 0) {
          mandantenBlockListe.forEach(block => {
            let eintragDatenbank = dbResponse.find(eintrag => block._id === eintrag._id);
            if (eintragDatenbank && block['revision'] !== eintragDatenbank.revision) {
              idListe.push(block._id);
            }
          });
        }else{
          mandantenBlockListe.forEach(block => {
            idListe.push(block._id)
          })
        }
        if (idListe.length === 0) {
          return of([]);
        }
        return this.apiCallService.request('/public', 'content/get', {
          mandantId: environment.mandant_id,
          contentItemIds: JSON.stringify(idListe),
          zweck: '',
          lang: 'de'
        }).pipe(
          switchMap((apiResponse: any[]) => {
            const addObservables = apiResponse.map(block => this.dbReaderService.addV2(block, block.zweck, 'Content'))
            return forkJoin(addObservables)
          })
        );
      }),
      map(dbAddResponses => {
        return dbAddResponses;
      })
    );
  }
}
